import { render, staticRenderFns } from "./Face2Pay1.vue?vue&type=template&id=3bfd627c&scoped=true&"
import script from "./Face2Pay1.vue?vue&type=script&lang=js&"
export * from "./Face2Pay1.vue?vue&type=script&lang=js&"
import style0 from "./Face2Pay1.vue?vue&type=style&index=0&id=3bfd627c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bfd627c",
  null
  
)

export default component.exports